import { 
  AlertDialog, 
  AlertDialogContent, 
  AlertDialogDescription, 
  AlertDialogFooter, 
  AlertDialogHeader, 
  AlertDialogTitle 
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle, Info } from "lucide-react";
import { JobHubJob } from "@/lib/jobUtils";

interface PauseJobModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  job: JobHubJob | null;
  onConfirm: () => void;
}

export function PauseJobModal({ open, onOpenChange, job, onConfirm }: PauseJobModalProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="sm:max-w-[425px]" data-testid="pause-job-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-xl font-bold text-gray-900">
            Pause Job Listing
          </AlertDialogTitle>
          <AlertDialogDescription className="text-gray-600">
            Are you sure you want to pause "<span className="font-medium text-gray-900">{job?.title}</span>"? This action will:
          </AlertDialogDescription>
        </AlertDialogHeader>
        
        <div className="py-4">
          <div className="space-y-3">
            <div className="flex items-start gap-3 p-3 bg-amber-50 border border-amber-200 rounded-lg">
              <AlertTriangle className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
              <div className="text-sm">
                <p className="font-medium text-amber-800 mb-1">
                  Unpublish the job listing
                </p>
                <p className="text-amber-700">
                  Users will no longer be able to view or refer candidates to this position.
                </p>
              </div>
            </div>
            
            <div className="flex items-start gap-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
              <Info className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
              <div className="text-sm">
                <p className="font-medium text-blue-800 mb-1">
                  Existing referrals remain active
                </p>
                <p className="text-blue-700">
                  All current referrals and applications will continue to be processed normally.
                </p>
              </div>
            </div>
          </div>
        </div>

        <AlertDialogFooter>
          <Button 
            variant="secondary"
            size="sm"
            onClick={() => onOpenChange(false)}
            data-testid="cancel-pause-job"
          >
            Cancel
          </Button>
          <Button 
            variant="primary"
            size="sm"
            onClick={onConfirm}
            data-testid="confirm-pause-job"
          >
            Pause Job
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
